<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  currentStep: number
  steps: string[]
}>()


const progressStyle = computed(() => {
  if (props.steps.length <= 1) return { width: '0%' }
  const percentage = ((props.currentStep - 1) / (props.steps.length - 1)) * 100
  return { width: `${percentage}%` }
})
</script>

<template>
  <div class="relative mx-auto flex w-11/12 max-w-3xl items-center justify-between">
    
    <div class="absolute left-0 top-1/2 h-0.5 w-11/12 -translate-y-1/2 bg-gray-200 z-0"></div>
    
    <div 
      class="absolute left-0 top-1/2 h-0.5 -translate-y-1/2 bg-[#1d4ed8] transition-all duration-500 ease-out z-0"
      :style="progressStyle"
    ></div>

    <div 
      v-for="(step, index) in steps" 
      :key="index" 
      class="relative z-10 flex flex-col items-center bg-white px-2"
    >
      <div 
        class="flex h-10 w-10 items-center justify-center rounded-full border-2 text-sm font-bold transition-all duration-300"
        :class="[
          index + 1 <= currentStep 
            ? 'border-[#1d4ed8] bg-[#1d4ed8] text-white' 
            : 'border-gray-300 bg-white text-gray-400'  
        ]"
      >
        <span v-if="index + 1 < currentStep">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </span>
        <span v-else>{{ index + 1 }}</span>
      </div>
      
      <span 
        class="absolute top-12 w-32 text-center text-[10px] font-bold uppercase tracking-wider transition-colors duration-300"
        :class="index + 1 <= currentStep ? 'text-[#1d4ed8]' : 'text-gray-300'"
      >
        {{ step }}
      </span>
    </div>
  </div>
</template>